import * as React from "react";
import react, { useState } from "react";
import Container from "./styled";
import ReCAPTCHA from "react-google-recaptcha";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { IoMailOutline } from "react-icons/io5";
import axios from 'axios'

export default function FormularioFormaParte() {
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});

  // Captcha
  function onChange(value) {
    console.log("Captcha value:", value);
    setFormValues((prev) => ({ ...prev, ["captcha"]: value }));
  }

  // Inputs
  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  }

  function onFileUpload(event) {
    event.preventDefault();
    event.persist()
    console.log(event)
    if(event.target.files[0]){
      const { name } = event.target;
      setFormValues((prev) => ({ ...prev, [name]: {image: event.target.files[0], name: event.target.files[0].name }})) 
    }
  }

  // Validación del formulario
  const validateForm = (e) => {
    e.preventDefault();
    let errors = {};

    if (!formValues.nombreyapellido) {
      errors.nombreyapellido = "Este campo es requerido.";
    }

    if (!formValues.email) {
      errors.email = "Este campo es requerido.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Validar puesto
    if (!formValues.puesto) {
      errors.puesto = "Este campo es requerido.";
    } 

    // Validar CV
    if (!formValues.cv) {
       errors.cv = "Este campo es requerido.";
    }

    /*
    if (!formValues.captcha) {
      errors.captcha = "Este campo es requerido.";
    }
    */

    console.log(errors);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      console.log("Todo OK");
      sendMail()
    }
  };

  // Sube archivos al server
  const sendFiles = async (file) => {
    let bodyFormData = new FormData();
    bodyFormData.append('cv', file);
    const upFile = await axios.post('http://localhost:5000/api/upload_files', bodyFormData);
    let path = upFile.data.path
    return path
  }

  // Enviar mail
  const sendMail = async () => {
    const mailContent = `
      <html><body>
        <h2>Forma parte</h2>
        <p>Nombre: ${formValues.nombreyapellido}<p>
        <p>Email: ${formValues.email}<p>
        <p>Puesto: ${formValues.puesto}<p>
        <p>Linkedin: ${formValues.linkedin}<p>
        <p>${formValues.mensaje}<p>
      </body></html>
    `
    const filePath = await sendFiles(formValues.cv.image)
    if(filePath){
      // Data para el mail
      const mailData = {
        mail: [formValues.email],
        subject: `Forma parte`,
        htmlContent: mailContent,
        attachments: { path: filePath }
      };
      const sendMail = await axios.post('http://localhost:5000/send_email', mailData)
      console.log(sendMail)
    }
  }    
  return (
    <Container>
      {/* Formulario Container */}
      <div className="formularioTitleContainer opacidad08">
        {/* Title */}
        <h2>Formá Parte de SeguroBici!</h2>
        <form>
          {/* Nombre */}
          <div className="inputContainer">
            <label>
              Nombre y Apellido <span>*</span>
            </label>
            <input
              placeholder="Nombre y apellido"
              name="nombreyapellido"
              onChange={handleChange}
              value={formValues.nombreyapellido}
            ></input>
          </div>
          {/* Email */}
          <div className="inputContainer">
            <label>
              Email <span>*</span>
            </label>
            <input placeholder="ejemplo@mail.com" name="email" onChange={handleChange} value={formValues.email}></input>
          </div>
          {/* Puesto */}
          <div className="inputContainer">
            <label>
              Puesto <span>*</span>
            </label>
            <input placeholder="RR.HH" name="puesto" onChange={handleChange} value={formValues.puesto}></input>
          </div>
          {/* LinkedIn */}
          <div className="inputContainer">
            <label>LinkedIn</label>
            <input placeholder="www.linkedin.com" name="linkedin" onChange={handleChange} value={formValues.linkedin}></input>
          </div>
          {/* Mensaje */}
          <div className="inputContainer" id="mensaje">
            <label>Contanos tus pasiones y habilidades</label>
            <textarea
              placeholder="Queremos saber que te motiva"
              name="mensaje"
              onChange={handleChange}
              value={formValues.mensaje}
            ></textarea>
          </div>
          {/* Subir CV */}
          <div className="inputContainer">
            <p id="cvtext">
              Cargá tu CV (PDF) <span>*</span>
            </p>
            <label for="cv" id="cvbutton">
              Seleccionar
              <span>
                <BsFillFileEarmarkPdfFill></BsFillFileEarmarkPdfFill>
              </span>
            </label>
            <input
              type="file"
              name="cv"
              // Acepta PDFs, archivos de Word y texto plano
              accept="application/pdf"
              id="cv"
              onChange={(e)=> onFileUpload(e)}
            ></input>
          </div>
          {/* ReCAPTCHA Container */}
          <div className="reCaptchaContainer">
            <ReCAPTCHA
              sitekey="6LfvW5YdAAAAADsIry4KRJS5YkcRb7L20iJbYLzQ"
              onChange={onChange}
            />
          </div>
          <button id="formButton" onClick={validateForm}>
            <span>
              <IoMailOutline />
            </span>
            Enviar
          </button>
        </form>
      </div>
      {/* Ilustration Container */}
      <div className="ilustrationContainer opacidad12">
        {/* Ilustration */}
        <img
          alt="Seguro Bici Ilustracion"
          src="images/home/cotizador.svg"
        ></img>
      </div>
      {/* ReCAPTCHA */}
    </Container>
  );
}
